module.exports = __webpack_public_path__ + "static/media/champagna.27718a44.svg";